import React from "react"
import { Alert, IconButton } from "@mui/material"
import { X } from "lucide-mui"

interface AlertMessagesProps {
  successMessage: string | null
  errorMessage: string | null
  onCloseSuccess: () => void
  onCloseError: () => void
}

const AlertMessages: React.FC<AlertMessagesProps> = ({
  successMessage,
  errorMessage,
  onCloseSuccess,
  onCloseError,
}) => {
  return (
    <>
      {successMessage && (
        <Alert
          severity="success"
          data-testid="settings-venue-hours-alerts-success"
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={onCloseSuccess}>
              <X className="w-5 h-5" />
            </IconButton>
          }
        >
          {successMessage}
        </Alert>
      )}

      {errorMessage && (
        <Alert
          severity="error"
          data-testid="settings-venue-hours-alerts-error"
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={onCloseError}>
              <X className="w-5 h-5" />
            </IconButton>
          }
        >
          {errorMessage}
        </Alert>
      )}
    </>
  )
}

export default AlertMessages
